export default {"src":"/_next/static/media/redact-reduce-privacy-icon.0cd19b31.svg","height":40,"width":49,"blurWidth":0,"blurHeight":0};